module.exports = __webpack_public_path__ + "static/img/mod5.450c860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mod5.png
// module id = 431
// module chunks = 0